import script from "./VolumeHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./VolumeHead.vue?vue&type=script&lang=ts&setup=true"

import "./VolumeHead.vue?vue&type=style&index=0&id=552e1d77&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552e1d77"]])

export default __exports__